import styled from 'styled-components'
import {
  CircleAccent,
  SectionHeader,
  CalendarGrid,
} from './CalendarOfEventsBlock.styles'

export const HeaderContainer = styled(CalendarGrid)`
  margin-top: 40px;
`

export const RelatedContentCircleAccent = styled(CircleAccent)`
  border: 3px solid var(--graphic-accent-purple-1);
  grid-column: 1;
`

export const RelatedContentSectionHeader = styled(SectionHeader)`
  grid-column: 1;
`
